import { type FC, type SVGProps } from 'react';

export const ArrowUpIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.3576 8.59757L8.43083 1.76721C8.37725 1.70541 8.31102 1.65584 8.23661 1.62187C8.16221 1.58789 8.08137 1.57031 7.99958 1.57031C7.91778 1.57031 7.83695 1.58789 7.76254 1.62187C7.68814 1.65584 7.6219 1.70541 7.56833 1.76721L1.64333 8.59757C1.62542 8.61816 1.61381 8.64346 1.60988 8.67046C1.60595 8.69746 1.60987 8.72502 1.62116 8.74986C1.63245 8.77469 1.65064 8.79576 1.67356 8.81055C1.69649 8.82535 1.72319 8.83324 1.75047 8.83328H3.1969C3.27904 8.83328 3.35761 8.79757 3.41297 8.73507L7.3219 4.22971V14.2851C7.3219 14.3636 7.38618 14.4279 7.46476 14.4279H8.53618C8.61476 14.4279 8.67904 14.3636 8.67904 14.2851V4.22971L12.588 8.73507C12.6415 8.79757 12.7201 8.83328 12.804 8.83328H14.2505C14.3719 8.83328 14.438 8.69043 14.3576 8.59757Z"
    />
  </svg>
);
